const styles = {
  menuItem: {
    cursor: "pointer",
  }
};

export default styles;
